import { render } from "./SearchArguments.vue?vue&type=template&id=5f1f78e6&scoped=true"
import script from "./SearchArguments.vue?vue&type=script&lang=js"
export * from "./SearchArguments.vue?vue&type=script&lang=js"

import "./SearchArguments.vue?vue&type=style&index=0&id=5f1f78e6&scoped=true&lang=css"

import exportComponent from "/data/local/webspace/artflsrv04/html/philologic4.7/publicdicos/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1f78e6"]])

export default __exports__